"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalContentTheme = exports.modalActionsTheme = void 0;
var modalContentTheme = {
  root: {
    borderTop: 'none',
    padding: '0px 16px 24px 16px',
    fontSize: 16,
    overflowY: 'auto'
  }
};
exports.modalContentTheme = modalContentTheme;
var modalActionsTheme = {
  root: {
    padding: 16
  },
  spacing: {
    '& > *:not(:first-child)': {
      marginLeft: 16
    }
  }
};
exports.modalActionsTheme = modalActionsTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01vZGFsL21vZGFsVGhlbWUudHN4Il0sIm5hbWVzIjpbIm1vZGFsQ29udGVudFRoZW1lIiwicm9vdCIsImJvcmRlclRvcCIsInBhZGRpbmciLCJmb250U2l6ZSIsIm92ZXJmbG93WSIsIm1vZGFsQWN0aW9uc1RoZW1lIiwic3BhY2luZyIsIm1hcmdpbkxlZnQiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUdPLElBQU1BLGlCQUF3RSxHQUFHO0FBQ3RGQyxFQUFBQSxJQUFJLEVBQUU7QUFDSkMsSUFBQUEsU0FBUyxFQUFFLE1BRFA7QUFFSkMsSUFBQUEsT0FBTyxFQUFFLG9CQUZMO0FBR0pDLElBQUFBLFFBQVEsRUFBRSxFQUhOO0FBSUpDLElBQUFBLFNBQVMsRUFBRTtBQUpQO0FBRGdGLENBQWpGOztBQVNBLElBQU1DLGlCQUF3RSxHQUFHO0FBQ3RGTCxFQUFBQSxJQUFJLEVBQUU7QUFDSkUsSUFBQUEsT0FBTyxFQUFFO0FBREwsR0FEZ0Y7QUFJdEZJLEVBQUFBLE9BQU8sRUFBRTtBQUNQLCtCQUEyQjtBQUN6QkMsTUFBQUEsVUFBVSxFQUFFO0FBRGE7QUFEcEI7QUFKNkUsQ0FBakYiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBEaWFsb2dDb250ZW50Q2xhc3NLZXksIERpYWxvZ0FjdGlvbnNDbGFzc0tleSB9IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlJztcbmltcG9ydCB7IENTU1Byb3BlcnRpZXMgfSBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZS9zdHlsZXMvd2l0aFN0eWxlcyc7XG5cbmV4cG9ydCBjb25zdCBtb2RhbENvbnRlbnRUaGVtZTogUGFydGlhbDxSZWNvcmQ8RGlhbG9nQ29udGVudENsYXNzS2V5LCBDU1NQcm9wZXJ0aWVzPj4gPSB7XG4gIHJvb3Q6IHtcbiAgICBib3JkZXJUb3A6ICdub25lJyxcbiAgICBwYWRkaW5nOiAnMHB4IDE2cHggMjRweCAxNnB4JyxcbiAgICBmb250U2l6ZTogMTYsXG4gICAgb3ZlcmZsb3dZOiAnYXV0bycsXG4gIH0sXG59O1xuXG5leHBvcnQgY29uc3QgbW9kYWxBY3Rpb25zVGhlbWU6IFBhcnRpYWw8UmVjb3JkPERpYWxvZ0FjdGlvbnNDbGFzc0tleSwgQ1NTUHJvcGVydGllcz4+ID0ge1xuICByb290OiB7XG4gICAgcGFkZGluZzogMTYsXG4gIH0sXG4gIHNwYWNpbmc6IHtcbiAgICAnJiA+ICo6bm90KDpmaXJzdC1jaGlsZCknOiB7XG4gICAgICBtYXJnaW5MZWZ0OiAxNixcbiAgICB9LFxuICB9LFxufTtcbiJdfQ==